export interface OptionSection<T extends { group?: string }> {
    /** Heading for the section. Undefined for options with no group. */
    group?: string;
    options: T[];
}

/**
 * Splits options into sections of consecutive options that share a `group`.
 * Order is kept, so a group that reappears later becomes a second section.
 * Callers draw a separator between sections.
 */
export function groupOptions<T extends { group?: string }>(options: readonly T[]): OptionSection<T>[] {
    const sections: OptionSection<T>[] = [];

    for (const option of options) {
        const last = sections[sections.length - 1];
        if (last && last.group === option.group) {
            last.options.push(option);
        } else {
            sections.push({ group: option.group, options: [option] });
        }
    }

    return sections;
}
